import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ModalService } from '../../shared/services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  trigger,
  style,
  animate,
  transition,
  state,
} from '@angular/animations';
import { Router } from '@angular/router';
import { ReportService } from '../../core/http/report.service';

import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDatepicker } from '@angular/material/datepicker';
import * as _moment from 'moment';
const moment = _moment;
import * as XLSX from 'xlsx';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss'],
})
export class ReportComponent implements OnInit {
  @Output() dateChange: EventEmitter<MatDatepicker<any>> = new EventEmitter();
  mode: string = 'view';
  data: any = [];
  template: any = [];
  singleData: any = [];
  singleTemplate: any = [];
  params: any = [];
  id: number;
  reportId: string;
  selected;
  Errors: string;
  success;
  isLoading: boolean;
  loadLookUp: boolean = false;
  isLoadresult: boolean = false;
  lookUp: any = [];
  lstColumnNames: any = [];
  rowNames: any = [];
  lstParams: any = [];
  name = '';
  types;
  ACM: any = [];
  PYTMDS: any = [];
  Currency: any = [];
  CASHIER: any = [];
  DEPT: any = [];
  REFDOC: any = [];
  Access: boolean = false;
  fileName = 'ExcelSheet.xlsx';
  filteredOptions: Observable<string[]>;
  myControl = new FormControl();
  refDrName;
  refDrCode;
  drVisible: boolean = false;
  searchRef: any = [];
  refdrmode: boolean = false;
  Report = 'Report';
  // File Extension
  // File Status
  // Library Type
  // Storage Type

  refchg(value) {
    if (value == '') {
      this.drVisible = false;
    } else {
      this.drVisible = true;
    }
    this.searchRef = this.REFDOC.filter(
      (t) => t.Name.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }
  setACM(data) {
    this.lstParams = this.lstParams.filter(
      (data) => data.paramName !== 'Access Modes'
    );
    this.lstParams.push({
      paramName: 'Access Modes',
      paramValue: data.name,
      paramType: 'string',
    });
    console.log(this.lstParams);
  }
  setFEX(data) {
    this.lstParams = this.lstParams.filter(
      (data) => data.paramName !== 'File Extension'
    );
    this.lstParams.push({
      paramName: 'File Extension',
      paramValue: data.name,
      paramType: 'string',
    });
    console.log(this.lstParams);
  }
  setFLS(data) {
    this.lstParams = this.lstParams.filter(
      (data) => data.paramName !== 'File Status'
    );
    this.lstParams.push({
      paramName: 'File Status',
      paramValue: data.name,
      paramType: 'string',
    });
    console.log(this.lstParams);
  }
  setLBT(data) {
    this.lstParams = this.lstParams.filter(
      (data) => data.paramName !== 'Library Type'
    );
    this.lstParams.push({
      paramName: 'Library Type',
      paramValue: data.name,
      paramType: 'string',
    });
    console.log(this.lstParams);
  }
  setSTT(data) {
    this.lstParams = this.lstParams.filter(
      (data) => data.paramName !== 'Storage Type'
    );
    this.lstParams.push({
      paramName: 'Storage Type',
      paramValue: data.name,
      paramType: 'string',
    });
    console.log(this.lstParams);
  }

  constructor(public report: ReportService, private _snackBar: MatSnackBar) {}

  private _filter(value: any) {
    const filterValue = value.toLowerCase();

    return this.REFDOC.filter((option) =>
      option.Name.toLowerCase().includes(filterValue)
    );
  }

  ngOnInit(): void {
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map((value) => this._filter(value))
    );
    let ACM;
    let PYTMDS;
    let Currency;
    let CASHIER;
    let DEPT;
    let REFDOC;
    this.report.getReportLookUp('ACM').subscribe(
      (resSuccess) => {
        ACM = resSuccess;
        this.ACM = ACM.Result;
        console.log(this.ACM);
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );

    this.report.getReportLookUp('PYTMDS').subscribe(
      (resSuccess) => {
        PYTMDS = resSuccess;
        this.PYTMDS = PYTMDS.Result;
        console.log(this.PYTMDS);
        console.log(resSuccess);
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );

    this.report.getReportLookUp('Currency').subscribe(
      (resSuccess) => {
        Currency = resSuccess;
        this.Currency = Currency.Result;
        console.log(this.Currency);
        console.log(resSuccess);
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );

    this.report.getReportLookUp('CASHIER').subscribe(
      (resSuccess) => {
        CASHIER = resSuccess;
        this.CASHIER = CASHIER.Result;
        console.log(this.CASHIER);
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );

    this.report.getReportLookUp('DEPT').subscribe(
      (resSuccess) => {
        DEPT = resSuccess;
        this.DEPT = DEPT.Result;
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );

    this.report.getReportLookUp('REFDOC').subscribe(
      (resSuccess) => {
        REFDOC = resSuccess;
        this.REFDOC = REFDOC.Result;
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );

    this.report.getReportTemplate().subscribe(
      (resSuccess) => {
        this.data = resSuccess;
        this.template = this.data.Result;
        console.log(this.template);
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );

    this.report.getReportLookUpTypes().subscribe(
      (resSuccess) => {
        this.types = resSuccess;
        // console.log(resSuccess)
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );

    this.report.getReportLookUp('FEX').subscribe(
      (resSuccess) => {
        // this.data = resSuccess
        // this.template = this.data.result
        console.log(resSuccess);
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );
  }

  getTemplate() {
    this.isLoading = true;
    if (this.name) {
      this.report.getReportTemplateById(this.id).subscribe(
        (resSuccess) => {
          this.isLoading = false;
          this.singleData = resSuccess;
          this.singleTemplate = this.singleData.Result;
          console.log(this.singleTemplate);
          this.params = this.singleTemplate[0].ReportBuilderParameter;
          let i;
          for (i = 0; i < this.params.length; i++) {
            switch (this.params[i].Name) {
              case 'Access Modes':
                this.Access = true;
                break;
              case 'y':
                // code block
                break;
              default:
              // code block
            }
          }
          this.mode = 'result';
          console.log(this.params);
          // console.log(this.singleTemplate)
          // console.log(this.singleTemplate[0].reportBuilderParameter)
        },
        (resErr) => {
          this.isLoading = false;
          this._snackBar.open('Error: Please try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          console.log(resErr);
        }
      );
    } else {
      this.isLoading = false;
      this._snackBar.open('Please Select Template', '', {
        duration: 2000,
        verticalPosition: 'top',
      });
      console.log('error co');
    }
  }

  getLookUpData(code) {
    this.lookUp = [];
    let lookUp: any = [];
    this.report.getReportLookUp(code).subscribe(
      (resSuccess) => {
        this.loadLookUp = true;
        lookUp = resSuccess;
        this.lookUp = lookUp.result;
        console.log(this.lookUp);
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );
  }

  generate() {
    this.mode = 'result';
  }

  back() {
    this.mode = 'view';
    this.lstParams = [];
    this.Report = 'Report';
  }

  select(data) {
    console.log(data);

    this.selected = data;
    this.name = data.Name;
    this.Report = data.Name;
    this.id = this.selected.Id;
    this.lstColumnNames = [];
    this.rowNames = [];
    console.log(this.name);
    if (data.Id == 4) {
      this.refdrmode = true;
    } else {
      this.refdrmode = false;
    }
    console.log(this.refdrmode);
  }

  DateChange(event: any, name, param) {
    this.lstParams = this.lstParams.filter((data) => data.paramName !== name);
    this.lstParams.push({
      paramName: name,
      paramValue: moment(event.target.value).format('YYYY-MM-DD'),
      paramType: param,
    });
    console.log(this.lstParams);
    // console.log(moment(event.target.value).format('YYYY-MM-DD'), name, param)
    // dateOfBirth: moment("12/25/1995", "MM/DD/YYYY"),
  }
  onChange(event: any, name, param) {
    this.lstParams = this.lstParams.filter((data) => data.paramName !== name);
    this.lstParams.push({
      paramName: name,
      paramValue: event.target.value,
      paramType: param,
    });
    console.log(this.lstParams);
    // console.log(moment(event.target.value).format('YYYY-MM-DD'), name, param)
    // dateOfBirth: moment("12/25/1995", "MM/DD/YYYY"),
  }
  slectOnChange(event: any, name, param) {
    this.lstParams = this.lstParams.filter((data) => data.paramName !== name);
    this.lstParams.push({
      paramName: name,
      paramValue: event.value,
      paramType: param,
    });
    console.log(event.value, name, param);
    console.log(event);
  }

  setRefDr(dr, name, param) {
    this.refDrCode = dr.ref_doctor_code;
    this.refDrName = dr.Name;

    this.drVisible = false;
    this.lstParams = this.lstParams.filter((data) => data.paramName !== name);
    this.lstParams.push({
      paramName: name,
      paramValue: dr.Id,
      paramType: param,
    });
    console.log(dr.Id, name, param);
    console.log(event);
  }

  // public send(event){
  //   let checke = event.target.checked;
  //   if(checke){ //send if the value is true
  //     checke = false
  //   }
  //   }

  Form = new FormGroup({
    reportTemplateId: new FormControl(''),
    lstParams: new FormControl(this.lstParams),
  });

  onSubmit() {
    let lstRowData;
    this.rowNames = [];
    console.log(this.Form.value);

    this.isLoadresult = true;
    this.Form.patchValue({
      reportTemplateId: this.id,
      lstParams: this.lstParams,
    });
    const { reportTemplateId, lstParams } = this.Form.value;
    console.log(this.Form.value);
    this.report.generateReport(reportTemplateId, lstParams).subscribe(
      (resSuccess) => {
        this.rowNames = [];
        this.success = resSuccess;
        console.log(this.success);
        if (this.success) {
          if (!this.success.HasError) {
            this.isLoadresult = false;
            this.lstColumnNames = this.success.Result.lstColumnNames;
            let tdLenght = this.lstColumnNames.length;
            // this.rowNames = this.success.Result.lstRowData.slice(0, 9);
            this.isLoading = false;
            // console.log(this.rowNames);
            for (var i = 0; i < this.success.Result.lstRowData.length; i++) {
              // console.log(myStringArray[i]);
              this.rowNames.push(
                Object.entries(this.success.Result.lstRowData[i])
                  .slice(0, tdLenght)
                  .map((entry) => entry[1])
              );
            }
            console.log(this.rowNames);
            this.rowNames = this.sortByPropValue(
              this.rowNames,
              0,
              ''
            );
            Object.entries(this.success.Result.lstRowData)
              .slice(0, tdLenght)
              .map((entry) => entry[1]);
            this._snackBar.open('Result Generated', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
            this.Form.reset();
          } else {
            this.isLoadresult = false;
            this._snackBar.open('Error: something went wrong', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          }
        } else {
          this.isLoadresult = false;
          this.Errors = 'Not successful, please try again';
          this._snackBar.open('Error: something went wrong', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }
      },
      (resErr) => {
        this.isLoadresult = false;
        this._snackBar.open('Error: something went wrong', '', {
          duration: 2000,
          verticalPosition: 'top',
        });
        console.log(resErr);
      }
    );
  }

  sortByPropValue = (arr: any[], index: number, valueToMoveLast: any) => {
    return arr.sort((a, b) => {
      if (a[index] === valueToMoveLast) return 1;
      if (b[index] === valueToMoveLast) return -1;
      return 0; // Maintain order otherwise
    });
  };

  exportexcel(): void {
    /* table id is passed over here */
    let element = document.getElementById('table');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);
  }
}
